import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { canonicalUrl } from "@/lib/canonicalHost";
import { installZoomGuard } from "@/lib/noZoom";

// One address for everyone: www.<site> hops to the apex before anything renders (Cloudflare does the same with a 301).
const apex = canonicalUrl(window.location, process.env.REACT_APP_BACKEND_URL);
if (apex) window.location.replace(apex);
installZoomGuard();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
